var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { observer } from 'mobx-vue';
import { Component, Vue } from 'vue-property-decorator';
import Error from './error.vue';
import ViewToken from './views/token.vue';
import ViewVersion from './views/version.vue';
let default_1 = class extends Vue {
    get System() {
        return this.$Store.System;
    }
    get keepAlive() {
        return this.AppConfig.production;
    }
    get keepAliveProps() {
        const excludeFilterRoute = lodash.filter(this.$router.options.routes, (item) => {
            //商机不开启keepalive
            return ['smb-business', 'cons-clue'].some((x) => {
                return lodash.includes(item.name, x);
            });
        });
        const exclude = lodash.map(excludeFilterRoute, (item) => {
            return item.name;
        });
        return {
            include: [],
            exclude,
        };
    }
    get showPage() {
        return (lodash.includes([this.$Pages.Protocol_list.name], this.$route.name) ||
            this.System.LoggedIn);
    }
    mounted() { }
    updated() { }
    destroyed() { }
};
default_1 = __decorate([
    observer,
    Component({
        components: { Error, ViewToken, ViewVersion },
    })
], default_1);
export default default_1;
